export const GET_PROMOTION_REQUESTS_REQUEST = "GET_PROMOTION_REQUESTS_REQUEST";

export const GET_PROMOTION_REQUESTS_RESPONSE =
  "GET_PROMOTION_REQUESTS_RESPONSE";

export const EDIT_PROMOTION_REQUEST_REQUEST = "EDIT_PROMOTION_REQUEST_REQUEST";
